var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7233 7.16111C13.7233 6.68528 13.6847 6.20688 13.6024 5.73877H7V8.43426H10.7809C10.624 9.30361 10.1199 10.0727 9.38171 10.5613V12.3103H11.6374C12.962 11.0912 13.7233 9.29075 13.7233 7.16111Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99738 14C8.88526 14 10.4773 13.3802 11.6373 12.3102L9.38166 10.5612C8.75408 10.9882 7.94389 11.23 6.99995 11.23C5.17381 11.23 3.62544 9.99794 3.06988 8.34155H0.742188V10.1446C1.93047 12.5083 4.35076 14 6.99738 14Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.06973 8.3417C2.77651 7.47235 2.77651 6.53099 3.06973 5.66164V3.85864H0.744605C-0.248202 5.83654 -0.248202 8.1668 0.744605 10.1447L3.06973 8.3417Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99738 2.77056C7.99533 2.75512 8.95985 3.13064 9.68259 3.81995L11.6811 1.82147C10.4156 0.633193 8.73608 -0.0201046 6.99738 0.000471708C4.35076 0.000471708 1.93047 1.49225 0.742188 3.85853L3.06731 5.66153C3.6203 4.00256 5.17124 2.77056 6.99738 2.77056Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.426bc82d4beb127be4bea903387b867f.svg";
export { ForwardRef as ReactComponent };